module.exports = __webpack_public_path__ + "img/box3_img3_active_dark.dd818875.png";